import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Footer from './components/Footer';
import Aboutus from './pages/About';
import Termcondition from './pages/Termcondition';
import Privacy from './pages/Privacy';
import RefundPolicy from './pages/Refund policy';
import Packages from './pages/Packages';
import GallerySection from './pages/GallerySection';
import ContactSection from './pages/ContactSection';
import EnquiryForm from './pages/EnquiryForm';
import ActivitiesSection from './pages/ActivitiesSection';
import Videos from './pages/videoes';
import AttractionsInMalthan from './pages/AttractionsInMalthan';
import Bestpicnicspotnearnagpur from './pages/Best picnic spot near Nagpur';
import Onedaytournearnagpur from './pages/1 Day Tour Near Nagpur';
import ScrollToTop from './components/ScrollToTop';
import Familypicnicspotnearnagpur from './pages/Family Picnic Spot Near Nagpur';
import Nearestpicnicspotinnagpur from './pages/Nearest Picnic Spot in Nagpur';
import Destinationweddingsportnearnagpur from './pages/Destination Wedding Spots Near Nagpur';
import Preweddingdestinationnearnagpur from './pages/Pre Wedding Destination Near Nagpur';
import Onedayadventurersortnearnagpur from './pages/One Day Adventure Resorts Near Nagpur';
import Activitiesresortnearnagpur from './pages/Activities Resort Near Nagpur';
import Bestpicnicspotnearakola from './pages/Best Picnic Spot Near Akola';
import Onedaytournearakola from './pages/One Day Tour Near Akola';
import Resortnearakolaforfamily from './pages/Resorts Near Akola for Family';
import Destinationweddingresortnearakola from './pages/Destination Wedding Resorts Near Akola';
import Bestpicnicspotnearamravati from './pages/Best Picnic Spot Near Amravati';
import Onedaytournearamravati from './pages/One Day Tour Near Amravati';
import Faimilyresortnearamravati from './pages/Family Resorts Near Amravati';
import Preweddinglocationnearamravati from './pages/Pre-wedding Location Near Amravati';
import Picnicspotnearbhandara from './pages/Picnic Spot Near Bhandara';
import Onedaytripnearbhandara from './pages/One Day Trip Near Bhandara';
import Resortnearbhandaraforfamilyouting from './pages/Resorts Near Bhandara for Family Outing';
import Destinationweddingplacenearbhnadara from './pages/Destination Wedding Place Near Bhandara';
import Bestpicnicspotnearbuldhana from './pages/Best Picnic Spot Near Buldhana';
import Onedaytournearbuldhana from './pages/One Day Tour Near Buldhana';
import Familyresortnearbuldhana from './pages/Family Resorts Near Buldhana';
import Weddingdestinationnearbuldhana from './pages/Wedding Destination Near Buldhana';
import Picnicspotnearchandrapur from './pages/Picnic Spot Near Chandrapur';
import Onedaytournearchandrapur from './pages/One Day Tour Near Chandrapur';
import Adventureresortnearchandrapur from './pages/Adventure Resorts Near Chandrapur';
import Destinationweddingresortnearchandrapur from './pages/Destination Wedding Resort Near Chandrapur';
import Picninspotneargadchiroli from './pages/Picnic Spot Near Gadchiroli';
import Onedaytripneargadchiroli from './pages/One Day Trip Near Gadchiroli';
import Familyresortneargadchiroli from './pages/Family Resort Near Gadchiroli';
import Preweddingdestinationneargadchirily from './pages/Pre-wedding Destination Near Gadchiroli';
import Bestpicnicspotneargondia from './pages/Best Picnic Spot Near Gondia';
import Onedaytourneargondia from './pages/One Day Tour Near Gondia';
import Familyrsortneargondia from './pages/Family Resorts Near Gondia';
import Destinationweddingresortneargondia from './pages/Destination Wedding Resorts Near Gondia';
import Picnicspotnearwardha from './pages/Picnic Spot Near Wardha';
import Onedaytournearwardha from './pages/One Day Tour Near Wardha';
import Familyresortsnearwardha from './pages/Family Resorts Near Wardha';
import Weddingdestinationnearwardha from './pages/Wedding Destination Near Wardha';
import Picnicspotnearwashish from './pages/Picnic Spot Near Washim';
import Onedaytripnearwashim from './pages/One Day Trip Near Washim';
import Resortnearwashimforfamily from './pages/Resorts Near Washim for Family';
import Destinationweddingnearwashim from './pages/Destination Wedding Near Washim';
import Bestpicnicspotnearyavatmal from './pages/Best Picnic Spot Near Yavatmal';
import Onedaytournearyavatmal from './pages/One Day Tour Near Yavatmal';
import Familyresortnearyavatmal from './pages/Family Resorts Near Yavatmal';
import Preweddingresortnearyavatmal from './pages/Pre-wedding Resort Near Yavatmal';
import Luxuryresortinnagpurdistricwihforestview from './pages/Luxury Resort in Nagpur District with Forest View';
import Adventureresortinnagpurdistrictwithtigersafari from './pages/Adventure Resort in Nagpur District with Tiger Safari';
import Familyresortinnagpurdistrictsurroundedbynature from './pages/Family Resort in Nagpur District Surrounded by Nature';
import Coupleresortinnagpurdistricinjungle from './pages/Couple Resort in Nagpur District in Jungle';
import Privateresortinnagpurdistricwithswimmingpool from './pages/Private Resort in Nagpur District with Swimming Pool';
import Ecofriendlyresortinnagpurdistrict from './pages/Eco-friendly Resort in Nagpur District';
import Resortinnagpurdistrictwithoutdoor from './pages/Resort in Nagpur District with Outdoor Activities';
import Farmstayinnagpur from './pages/Farm Stay in Nagpur';
import Natureresortinnagpur from './pages/Nature Resort in Nagpur';
import Adventuresportsinnagpurdistric from './pages/Adventure Sports Resort in Nagpur District';
import Preweddingresortinnagpur from './pages/Pre-wedding Resort in Nagpur District in Forest';
import Resortinnagpurdistricforcorporateouting from './pages/Resort in Nagpur District for Corporate Outings';
import WoodlandEscapeBookingForm from './components/WoodlandEscapeBookingForm';
import ContactButtons from './components/ContactButtons';
import NearbyAttractions from './pages/NearbyAttractions';
import VideoSection from './pages/VideoSection';
import Food from './pages/Food';
import GoaComingSoon from './components/GoaComingSoon ';


function App() {
  return (
    <Router>
      <ScrollToTop />
      <ContactButtons/>
      <Header />
      <Routes>

        <Route path="/" element={<Hero />} />
        <Route path="/rooms" element={<Aboutus />} />
        <Route path="/food" element={<Food />} />
        <Route path="/Term-condition" element={<Termcondition />} />
        <Route path="/Privacy-policy" element={<Privacy />} />
        <Route path="/Refund-policy" element={<RefundPolicy />} />
        <Route path="/Near-by-Attractions" element={<NearbyAttractions />} />
        <Route path="/package" element={<Packages />} />
        <Route path="/gallery" element={<GallerySection />} />
        <Route path="/goa-resort-coming-soon" element={<GoaComingSoon />} />
        <Route path="/videos" element={<VideoSection />} />
        <Route path="/contact" element={<ContactSection />} />
        <Route path="/enquiry" element={<EnquiryForm />} />
        <Route path="/Activities" element={<ActivitiesSection />} />
        <Route path="/Online-booking" element={<WoodlandEscapeBookingForm />} />

<Route path="/One-Day-Tour-Near-Nagpur" element={<Onedaytournearnagpur />} />
        <Route path="/Best‑Picnic‑Spot‑Near‑Nagpur" element={<Bestpicnicspotnearnagpur />} />
<Route path="/Family-Picnic-Spot-Near-Nagpur" element={<Familypicnicspotnearnagpur />} />
<Route path="/Nearest-Picnic-Spot-In-Nagpur" element={<Nearestpicnicspotinnagpur />} />
<Route path="/Destination-Wedding-Spots-Near-Nagpur" element={<Destinationweddingsportnearnagpur />} />
<Route path="/Pre-Wedding-Destination-Near-Nagpur" element={<Preweddingdestinationnearnagpur />} />
<Route path="/One-Day-Adventure-Resorts-Near-Nagpur" element={<Onedayadventurersortnearnagpur />} />
<Route path="/Activities-Resort-Near-Nagpur" element={<Activitiesresortnearnagpur />} />
<Route path="/Best-Picnic-Spot-Near-Akola" element={<Bestpicnicspotnearakola />} />
<Route path="/One-Day-Tour-Near-Akola" element={<Onedaytournearakola />} />
<Route path="/Resorts-Near-Akola-For-Family" element={<Resortnearakolaforfamily />} />
<Route path="/Destination-Wedding-Resorts-Near-Akola" element={<Destinationweddingresortnearakola />} />
<Route path="/Best-Picnic-Spot-Near-Amravati" element={<Bestpicnicspotnearamravati />} />
<Route path="/One-Day-Tour-Near-Amravati" element={<Onedaytournearamravati />} />
<Route path="/Family-Resorts-Near-Amravati" element={<Faimilyresortnearamravati />} />
<Route path="/Pre-Wedding-Location-Near-Amravati" element={<Preweddinglocationnearamravati />} />
<Route path="/Picnic-Spot-Near-Bhandara" element={<Picnicspotnearbhandara />} />
<Route path="/One-Day-Trip-Near-Bhandara" element={<Onedaytripnearbhandara />} />
<Route path="/Resorts-Near-Bhandara-For-Family-Outing" element={<Resortnearbhandaraforfamilyouting />} />
<Route path="/Destination-Wedding-Place-Near-Bhandara" element={<Destinationweddingplacenearbhnadara />} />
<Route path="/Best-Picnic-Spot-Near-Buldhana" element={<Bestpicnicspotnearbuldhana />} />
<Route path="/One-Day-Tour-Near-Buldhana" element={<Onedaytournearbuldhana />} />
<Route path="/Family-Resorts-Near-Buldhana" element={<Familyresortnearbuldhana />} />
<Route path="/Wedding-Destination-Near-Buldhana" element={<Weddingdestinationnearbuldhana />} />
<Route path="/Picnic-Spot-Near-Chandrapur" element={<Picnicspotnearchandrapur />} />
<Route path="/One-Day-Tour-Near-Chandrapur" element={<Onedaytournearchandrapur />} />
<Route path="/Adventure-Resorts-Near-Chandrapur" element={<Adventureresortnearchandrapur />} />
<Route path="/Destination-Wedding-Resort-Near-Chandrapur" element={<Destinationweddingresortnearchandrapur />} />
<Route path="/Picnic-Spot-Near-Gadchiroli" element={<Picninspotneargadchiroli />} />
<Route path="/One-Day-Trip-Near-Gadchiroli" element={<Onedaytripneargadchiroli />} />
<Route path="/Family-Resort-Near-Gadchiroli" element={<Familyresortneargadchiroli />} />
<Route path="/Pre-Wedding-Destination-Near-Gadchiroli" element={<Preweddingdestinationneargadchirily />} />
<Route path="/Best-Picnic-Spot-Near-Gondia" element={<Bestpicnicspotneargondia />} />
<Route path="/One-Day-Tour-Near-Gondia" element={<Onedaytourneargondia />} />
<Route path="/Family-Resorts-Near-Gondia" element={<Familyrsortneargondia />} />
<Route path="/Destination-Wedding-Resorts-Near-Gondia" element={<Destinationweddingresortneargondia />} />
<Route path="/Picnic-Spot-Near-Wardha" element={<Picnicspotnearwardha />} />
<Route path="/One-Day-Tour-Near-Wardha" element={<Onedaytournearwardha />} />
<Route path="/Family-Resorts-Near-Wardha" element={<Familyresortsnearwardha />} />
<Route path="/Wedding-Destination-Near-Wardha" element={<Weddingdestinationnearwardha />} />
<Route path="/Picnic-Spot-Near-Washim" element={<Picnicspotnearwashish />} />
<Route path="/One-Day-Trip-Near-Washim" element={<Onedaytripnearwashim />} />
<Route path="/Resorts-Near-Washim-For-Family" element={<Resortnearwashimforfamily />} />
<Route path="/Destination-Wedding-Near-Washim" element={<Destinationweddingnearwashim />} />
<Route path="/Best-Picnic-Spot-Near-Yavatmal" element={<Bestpicnicspotnearyavatmal />} />
<Route path="/One-Day-Tour-Near-Yavatmal" element={<Onedaytournearyavatmal />} />
<Route path="/Family-Resorts-Near-Yavatmal" element={<Familyresortnearyavatmal />} />
<Route path="/Pre-Wedding-Resort-Near-Yavatmal" element={<Preweddingresortnearyavatmal />} />
<Route path="/Luxury-Resort-In-Nagpur-District-With-Forest-View" element={<Luxuryresortinnagpurdistricwihforestview />} />
<Route path="/Adventure-Resort-In-Nagpur-District-With-Tiger-Safari" element={<Adventureresortinnagpurdistrictwithtigersafari />} />
<Route path="/Family-Resort-In-Nagpur-District-Surrounded-By-Nature" element={<Familyresortinnagpurdistrictsurroundedbynature />} />
<Route path="/Couple-Resort-In-Nagpur-District-In-Jungle" element={<Coupleresortinnagpurdistricinjungle />} />
<Route path="/Private-Resort-In-Nagpur-District-With-Swimming-Pool" element={<Privateresortinnagpurdistricwithswimmingpool />} />
<Route path="/Eco-Friendly-Resort-In-Nagpur-District" element={<Ecofriendlyresortinnagpurdistrict />} />
<Route path="/Resort-In-Nagpur-District-With-Outdoor-Activities" element={<Resortinnagpurdistrictwithoutdoor />} />
<Route path="/Farm-Stay-In-Nagpur" element={<Farmstayinnagpur />} />
<Route path="/Nature-Resort-In-Nagpur" element={<Natureresortinnagpur />} />
<Route path="/Adventure-Sports-Resort-In-Nagpur-District" element={<Adventuresportsinnagpurdistric />} />
<Route path="/Pre-Wedding-Resort-In-Nagpur-District-In-Forest" element={<Preweddingresortinnagpur />} />
<Route path="/Resort-In-Nagpur-District-For-Corporate-Outings" element={<Resortinnagpurdistricforcorporateouting />} />




      </Routes>
     <div className='dark_bg'>
 <Footer />

     </div>
    </Router>


  );
}

export default App;
